import { FC } from 'react'
import { Row } from 'react-bootstrap'
import i18n from 'src/i18n'
import { step_director_t } from 'src/types'

import { Button } from '../button/button'

export const StepDirector: FC<step_director_t> = ({
  on_back,
  on_next,
  back_label = i18n.t('commons.back'),
  next_label = i18n.t('commons.next'),
  next_disabled,
  next_hidden = false,
  form_id,
  classes = 'm-0 p-0 mt-5',
  gtm_class,
}: step_director_t) => {
  return (
    <Row className={classes}>
      {on_back && (
        <Button flavor="grey_flip" text={back_label} classes="mr-5 p-0" on_press={on_back} />
      )}
      {!next_hidden && (
        <Button
          flavor="primary_next"
          type="submit"
          form_id={form_id}
          text={next_label}
          on_press={on_next}
          disabled={next_disabled}
          classes={gtm_class}
        />
      )}
    </Row>
  )
}
